<template>
  <v-card dark flat class="app-store-card" role="region" aria-labelledby="app-store-title">
    <v-btn icon class="app-store-card__close" aria-label="Store-Hinweis schliessen" @click="$emit('close')">
      <v-icon aria-hidden="true">mdi-close</v-icon>
    </v-btn>

    <div class="app-store-card__brand">
      <div class="app-store-card__logo-surface">
        <img :src="brandLogo" alt="WELL COME FIT" width="1200" height="931" />
      </div>
      <span class="app-store-card__badge">
        <span aria-hidden="true"></span>
        Offizielle App
      </span>
    </div>

    <header class="app-store-card__header">
      <span class="app-store-card__eyebrow">WELL COME FIT App</span>
      <h2 id="app-store-title">Dein Training. Direkt auf deinem Homescreen.</h2>
      <p>Installiere die App und öffne Kurse, Trainings und dein Studio ohne Umwege.</p>
    </header>

    <div class="app-store-card__benefits" aria-label="App-Vorteile">
      <span><v-icon aria-hidden="true">mdi-lightning-bolt-outline</v-icon>Schneller Zugriff</span>
      <span><v-icon aria-hidden="true">mdi-bell-outline</v-icon>Direkte Updates</span>
    </div>

    <div class="app-store-card__actions">
      <a
        class="app-store-badge-link"
        title="WELL COME FIT im App Store öffnen"
        target="_blank"
        rel="noopener noreferrer"
        href="https://apps.apple.com/de/app/roody/id1641472611">
        <img class="app-store-badge-image" src="/img/einmalig/appstoreBadge.svg" alt="Laden im App Store" />
      </a>

      <a
        class="app-store-badge-link"
        title="WELL COME FIT bei Google Play öffnen"
        target="_blank"
        rel="noopener noreferrer"
        href="https://play.google.com/store/apps/details?id=ch.wellcomefit.roody&gl=US&pli=1">
        <img class="app-store-badge-image" src="/img/einmalig/googlePlayBadge.png" alt="Jetzt bei Google Play" />
      </a>
    </div>

    <div class="app-store-card__foot">
      <v-icon aria-hidden="true">mdi-shield-check-outline</v-icon>
      <span>Die offizielle App von WELL COME FIT</span>
    </div>
  </v-card>
</template>

<script>
import { brandLogo } from "@/constants/brandAssets"

export default {
  name: "AppStoreRedirectCard",
  data() {
    return {
      brandLogo,
    }
  },
}
</script>

<style lang="scss">
.app-store-dialog {
  width: calc(100% - 28px) !important;
  max-width: 430px !important;
  max-height: calc(100vh - 28px) !important;
  max-height: calc(100dvh - 28px) !important;
  margin: 14px !important;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 26px !important;
  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.5) !important;
  overscroll-behavior-y: contain;
  scrollbar-width: none;
}

.app-store-dialog::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.app-store-card.v-card {
  --store-accent: #42944a;
  --store-accent-soft: rgba(66, 148, 74, 0.14);
  position: relative;
  padding: 30px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 26px !important;
  color: #fbfbfb !important;
  background: radial-gradient(circle at 8% 5%, rgba(66, 148, 74, 0.2), transparent 34%),
    linear-gradient(150deg, #272927 0%, #1e201e 54%, #191b19 100%) !important;
  font-family: "Saira", sans-serif;
}

.app-store-card.v-card::after {
  position: absolute;
  top: -150px;
  right: -145px;
  width: 300px;
  height: 300px;
  border: 1px solid rgba(66, 148, 74, 0.18);
  border-radius: 50%;
  box-shadow: 0 0 0 46px rgba(66, 148, 74, 0.025);
  content: "";
  pointer-events: none;
}

.app-store-card__close.v-btn {
  position: absolute !important;
  z-index: 3;
  top: 14px;
  right: 14px;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #dfe2df !important;
  background: rgba(19, 21, 19, 0.62) !important;
  backdrop-filter: blur(12px);
}

.app-store-card__close.v-btn:focus-visible,
.app-store-badge-link:focus-visible {
  outline: 3px solid rgba(100, 181, 108, 0.95) !important;
  outline-offset: 3px;
}

.app-store-card__brand {
  position: relative;
  z-index: 1;
  display: flex;
  min-height: 96px;
  gap: 14px;
  padding-right: 48px;
  align-items: center;
}

.app-store-card__logo-surface {
  display: flex;
  width: 112px;
  height: 88px;
  padding: 8px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  background: rgba(20, 22, 20, 0.45);
}

.app-store-card__logo-surface img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.app-store-card__badge {
  display: inline-flex;
  min-height: 29px;
  gap: 8px;
  padding: 6px 10px;
  align-items: center;
  border: 1px solid rgba(66, 148, 74, 0.32);
  border-radius: 9px;
  color: #d7ead9;
  background: var(--store-accent-soft);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.app-store-card__badge span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #65b06d;
  box-shadow: 0 0 0 4px rgba(66, 148, 74, 0.13);
}

.app-store-card__header {
  position: relative;
  z-index: 1;
  margin-top: 24px;
}

.app-store-card__eyebrow {
  display: block;
  margin-bottom: 9px;
  color: #72bd79;
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.app-store-card__header h2 {
  max-width: 350px;
  margin: 0;
  color: #fbfbfb;
  font-size: 2rem;
  font-weight: 820;
  letter-spacing: -0.045em;
  line-height: 1.04;
}

.app-store-card__header p {
  margin: 13px 0 0;
  color: #aeb2ae;
  font-size: 0.82rem;
  line-height: 1.55;
}

.app-store-card__benefits {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 8px;
  margin-top: 18px;
  flex-wrap: wrap;
}

.app-store-card__benefits span {
  display: inline-flex;
  min-height: 34px;
  gap: 6px;
  padding: 6px 9px;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #cfd3cf;
  background: rgba(255, 255, 255, 0.025);
  font-size: 0.66rem;
  font-weight: 680;
}

.app-store-card__benefits .v-icon {
  color: #72bd79 !important;
  font-size: 16px !important;
}

.app-store-card__actions {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 2px;
  margin-top: 24px;
  justify-items: center;
}

.app-store-badge-link {
  display: flex;
  width: min(210px, 100%);
  min-height: 76px;
  padding: 13px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  text-decoration: none;
}

.app-store-badge-image {
  display: block;
  width: auto;
  max-width: 100%;
  height: 50px;
  object-fit: contain;
}

.app-store-card__foot {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 7px;
  margin-top: 18px;
  align-items: center;
  justify-content: center;
  color: #858985;
  font-size: 0.62rem;
  text-align: center;
}

.app-store-card__foot .v-icon {
  color: #69ad6f !important;
  font-size: 16px !important;
}

@media (hover: hover) and (pointer: fine) {
  .app-store-card__close.v-btn:hover {
    border-color: rgba(255, 255, 255, 0.22);
    color: #fff !important;
    background: rgba(255, 255, 255, 0.09) !important;
  }

  .app-store-badge-link:hover {
    background: rgba(255, 255, 255, 0.035);
  }
}

@media (max-width: 480px) {
  .app-store-dialog {
    width: calc(100% - 20px) !important;
    max-height: calc(100vh - 20px) !important;
    max-height: calc(100dvh - 20px) !important;
    margin: 10px !important;
    border-radius: 22px !important;
  }

  .app-store-card.v-card {
    padding: 24px 18px max(20px, env(safe-area-inset-bottom));
    border-radius: 22px !important;
  }

  .app-store-card__close.v-btn {
    top: 12px;
    right: 12px;
    width: 40px;
    height: 40px;
  }

  .app-store-card__brand {
    min-height: 78px;
    gap: 10px;
    padding-right: 42px;
  }

  .app-store-card__logo-surface {
    width: 94px;
    height: 74px;
    padding: 7px;
    border-radius: 15px;
  }

  .app-store-card__badge {
    padding: 5px 8px;
    font-size: 0.55rem;
  }

  .app-store-card__header {
    margin-top: 20px;
  }

  .app-store-card__header h2 {
    font-size: 1.72rem;
  }

  .app-store-card__header p {
    font-size: 0.78rem;
  }

  .app-store-card__benefits {
    margin-top: 15px;
  }

  .app-store-card__benefits span {
    min-height: 32px;
    padding: 5px 8px;
    font-size: 0.61rem;
  }

  .app-store-card__actions {
    margin-top: 19px;
  }

  .app-store-badge-link {
    min-height: 76px;
  }
}

@media (max-height: 650px) {
  .app-store-card.v-card {
    padding-top: 20px;
    padding-bottom: 18px;
  }

  .app-store-card__brand {
    min-height: 66px;
  }

  .app-store-card__logo-surface {
    width: 82px;
    height: 64px;
  }

  .app-store-card__header,
  .app-store-card__actions {
    margin-top: 16px;
  }

  .app-store-card__benefits,
  .app-store-card__foot {
    display: none;
  }

  .app-store-card__header h2 {
    font-size: 1.55rem;
  }

  .app-store-card__header p {
    margin-top: 8px;
  }

  .app-store-badge-link {
    min-height: 68px;
  }

  .app-store-badge-image {
    height: 44px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .app-store-dialog,
  .app-store-dialog *,
  .app-store-dialog *::before,
  .app-store-dialog *::after {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
</style>
